import * as React from 'react';

import styles from './entity-list-mini.module.css';

const NUM_ROWS_SHOWN = 5;

type Props = {
    isHotLeadsList?: boolean;
    hasError?: boolean;
    footer?: React.ReactNode;
};

export class EntityListMiniEmptyState extends React.Component<Props> {
    render() {
        const emptyRows = Array.from({length: NUM_ROWS_SHOWN}, (v, k) => k + 1).map(
            (column, index) => {
                return <div key={`empty-cell-${index}`} className={styles['cell-container']} />;
            }
        );

        let emptyText = this.props.isHotLeadsList
            ? 'Add hot leads and track them here'
            : 'This list is currently empty';

        if (this.props.hasError) {
            emptyText = 'We couldn’t load your list right now';
        }

        return (
            <div className={styles['column-container']}>
                <div
                    className={
                        this.props.hasError ? styles['error-container'] : styles['empty-container']
                    }
                >
                    {emptyRows}
                    <div className={styles['empty-image-container']}>
                        <img
                            src={
                                this.props.isHotLeadsList
                                    ? '/include/images/dashboard/hot-leads-empty-state.svg'
                                    : '/include/images/dashboard/list-empty-state.svg'
                            }
                            className={styles['empty-image']}
                        />
                        <div className={styles['empty-text']}>
                            <span>{emptyText}</span>
                        </div>
                    </div>
                </div>
                {this.props.footer}
            </div>
        );
    }
}
